<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ZhuoDian`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 12.9141H4V12.4141H12V12.9141zM12 2.41406H4V1.91406H12V2.41406zM12 14.0859H4V13.5859H12V14.0859zM12 3.58594H4V3.08594H12V3.58594z"/><path d="M4 4.5H12V11.5H4V4.5Z"/></svg>
</template>
<script>

export default {
  name: 'IconZhuoDian',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
